import { render, staticRenderFns } from "./AssetSearch.vue?vue&type=template&id=b1bd7fa8&scoped=true&"
import script from "./AssetSearch.vue?vue&type=script&lang=ts&"
export * from "./AssetSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AssetSearch.vue?vue&type=style&index=0&id=b1bd7fa8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bd7fa8",
  null
  
)

export default component.exports